import { ParseKeys } from 'i18next'
import { CarLicenseeEmployeeTypeEnum } from '~/shared/config/enums'
import { EmployeesForm } from './model'

const mapSort = [
  CarLicenseeEmployeeTypeEnum.dispatcher,
  CarLicenseeEmployeeTypeEnum.controller,
  CarLicenseeEmployeeTypeEnum.doctor,
]

export const sortEmployees = (employees: EmployeesForm) => {
  return Object.entries(employees)
    .sort(
      ([, employeeA], [, employeeB]) =>
        mapSort.indexOf(employeeA.employeeType) -
        mapSort.indexOf(employeeB.employeeType),
    )
    .map(([id, data]) => ({ id, ...data }))
}

export const mappedDefaultValues = (employees: EmployeesForm) =>
  Object.fromEntries(
    Object.entries(employees).map(([id, data]) => [id, data.fullName]),
  )

export const getTextInputProps = (
  type: CarLicenseeEmployeeTypeEnum,
): { label: ParseKeys; placeholder: ParseKeys } => {
  switch (type) {
    case CarLicenseeEmployeeTypeEnum.dispatcher:
      return {
        label: 'form.dispatcher',
        placeholder: 'form.enter dispatcher full name',
      }
    case CarLicenseeEmployeeTypeEnum.controller:
      return {
        label: 'form.controller',
        placeholder: 'form.enter controller full name',
      }
    case CarLicenseeEmployeeTypeEnum.doctor:
      return { label: 'form.medic', placeholder: 'form.enter medic full name' }
  }
}
